import React from 'react';
import { IoIosHome } from 'react-icons/io';
import { Link } from 'react-router-dom';
import ItemCategoria from './ItemCategoria';

function CaminoCategorias({ caminoCategoria }) {
  return (
    <label className='font-bold text-GrisOscuro flex items-center'>
      <div className='mr-2'>
        <Link to={'/'}>
          <IoIosHome />
        </Link>
      </div>
      {caminoCategoria.map((c, index) => (
        <React.Fragment key={index}>
          {/* Renderizamos la categoría */}
          <ItemCategoria
            item={c}
            caminoCategoria={caminoCategoria}
            isLast={index === caminoCategoria.length - 1} // Verifica si es el último elemento
          />
          {/* Insertamos el separador '>' si no es el último */}
          {index < caminoCategoria.length - 1 && (
            <span className='mx-1'>{'>'}</span>
          )}
        </React.Fragment>
      ))}
    </label>
  );
}

export default CaminoCategorias;
